import styled from 'styled-components';
import cn from 'classnames';

export const Title = styled.div`
  display: none;
  position: absolute;
  font-size: 13px;
  top: 34px;
  left: -16px;
  text-align: center;
  z-index: 1;
  transition: var(--transition);
  white-space: nowrap;

  &:before {
    content: '';
    position: absolute;
    left: 16px;
    top: -3px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 6px 40px;
    width: 16px;
    height: 16px;
    transform: rotate(45deg);
    z-index: 0;
    background: var(--white);
  }
`;

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  padding: 8px 12px;
  background: #fff;
  box-shadow: 0px 5px 23px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
`;

export const Helper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &:hover ${Title} {
    display: block;
  }
`;

export const Icon = styled.svg.attrs(
  ({ active, classes, name, size, style, ...props }) => ({
    className: cn([classes], 'icon', {
      [active]: !!active,
      [`icon_${name}`]: name,
      icon_tiny: size === 'tiny',
      icon_small: size === 'small',
      icon_middle: size === 'middle',
      icon_large: size === 'large',
      icon_rounded: props.rounded,
    }),
    style,
  })
)`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1em;
  height: 1em;
  fill: currentColor;

  &.icon_tiny {
    font-size: 16px;
  }

  &.icon_small {
    font-size: 20px;
  }

  &.icon_medium {
    font-size: 24px;
  }

  &.icon_large {
    font-size: 32px;
  }

  &.icon_heart {
    fill: none;
    stroke: var(--carbone100);
    stroke-width: 1.7;
  }

  &.icon_rounded {
    border-radius: 50%;
  }
`;
